import { useSiteSettings } from "../../../contexts/SiteSettingsContext";

export default function FooterTab() {
  const { settings, updateSettings } = useSiteSettings();

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-sm font-bold text-gray-700 mb-4 pb-2 border-b border-gray-200">フッター設定</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">フッタータイトル</label>
            <input
              type="text"
              value={settings.footerTitle}
              onChange={(e) => updateSettings({ footerTitle: e.target.value })}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
              placeholder="サイト名"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">コピーライト</label>
            <input
              type="text"
              value={settings.footerCopyright}
              onChange={(e) => updateSettings({ footerCopyright: e.target.value })}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
              placeholder="© 2024 サイト名."
            />
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => updateSettings({ footerAdminLink: !settings.footerAdminLink })}
              className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors cursor-pointer ${
                settings.footerAdminLink ? "bg-red-500" : "bg-gray-200"
              }`}
            >
              <span className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${settings.footerAdminLink ? "translate-x-[18px]" : "translate-x-[3px]"}`} />
            </button>
            <span className="text-sm text-gray-600">フッターに管理ページへのリンクを表示する</span>
          </div>
          <p className="text-xs text-gray-400">管理リンクを非表示にした場合は <code className="bg-gray-100 px-1 rounded">/admin</code> を直接入力してアクセスしてください。</p>
        </div>
      </div>
    </div>
  );
}
